import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function medidor(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@medidor/FIND_MEDIDOR':
      case '@medidor/UPDATE_MEDIDOR':
      case '@medidor/DELETE_MEDIDOR':
      case '@medidor/STORE_MEDIDOR':
      case '@medidor/MEDIDORES_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@medidor/SUCCESS_REMOVE':
      case '@medidor/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@medidor/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.medidores;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@medidor/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.medidor;
        break;
      }

      case '@medidor/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
